export default {
  searchFilter: '',
  processStepSearchFilter: '',
  stepOptionSeachFilter: '',
  data: []
}
